import Header from '../components/Header';
import Hero from '../components/Hero';

const Home = () => {
  return (
    <div className='bg-discord_blue'>
      <Header />
      <Hero />
    </div>
  );
};

export default Home;
